import { FILE_OPTIONS } from '../flow/checkboxOptions';
import { MatcherGenericCheckboxStep } from '../components';

function MatcherFileStep() {
  return (
    <MatcherGenericCheckboxStep
      questionId="file"
      title="Anything that makes your return more complex?"
      options={FILE_OPTIONS}
      stepName="matcher_file_step"
    />
  );
}

export { MatcherFileStep };
